// src/utils/facebookPixel.js
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const PIXEL_ID = process.env.REACT_APP_PIXEL_ID;

export function useFacebookPixel() {
  const location = useLocation();
  const fbLoaded = useRef(false);

  useEffect(() => {
    if (!PIXEL_ID) {
      console.warn("No se encuentra PixelID");
      return;
    }

    if (fbLoaded.current) {
      window.fbq && window.fbq('track', 'PageView');
      return;
    }

    window.fbq = window.fbq || function () {
      window.fbq.callMethod
        ? window.fbq.callMethod.apply(window.fbq, arguments)
        : window.fbq.queue.push(arguments);
    };
    window.fbq.queue = window.fbq.queue || [];
    window.fbq.loaded = true;
    window.fbq.version = "2.0";

    const fbScript = document.createElement("script");
    fbScript.src = "https://connect.facebook.net/en_US/fbevents.js";
    fbScript.async = true;

    fbScript.onload = () => {
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
      fbLoaded.current = true;
    };

    document.body.appendChild(fbScript);
    if (!document.getElementById("fb-pixel-noscript")) {
      const noscript = document.createElement("noscript");
      noscript.id = "fb-pixel-noscript";
      noscript.innerHTML = `
        <img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1" />
      `;
      document.body.appendChild(noscript);
    }

  }, [location.pathname]);
}
